import { Box, Heading, Button, Flex } from "@chakra-ui/react";
import { AirhelpPlus } from "@airhelp/react";
import Link from "next/link";
import type { SbEditableComponentProps } from "types/storyblok";
import { trackUAClickEvent, trackCustomEvent } from "utils/tracking/utils";
import type { ImageCTAProps } from "../ImageCTA.d";
import { ImageCTAStylesMobile } from "./ImageCTAMobile.styles";

const ImageCTAMobile = ({
  text,
  buttonText,
  buttonHref = "/404",
  imageUrl,
  gtmSection,
  gtmElement,
  gaLabel,
  gaPlacement,
  variant,
  sbEditable,
}: SbEditableComponentProps<ImageCTAProps>) => {
  const trackingEvents = () => {
    trackUAClickEvent(gtmSection, gtmElement);
    trackCustomEvent({ event: "cta_click", label: gaLabel, placement: gaPlacement });
  };

  return (
    <Flex w="full" overflow="auto" direction="column" sx={ImageCTAStylesMobile[variant].container} {...sbEditable}>
      <Box bgImage={imageUrl} bgRepeat="no-repeat" bgSize="cover" sx={ImageCTAStylesMobile[variant].image} />
      <Box zIndex="1" sx={ImageCTAStylesMobile[variant].textContainer}>
        {variant === "ahPlus" && <AirhelpPlus h={9} w="auto" mb={4} />}
        <Heading color="inherit" {...ImageCTAStylesMobile[variant].heading}>
          {text}
        </Heading>
        <Link href={buttonHref}>
          <Button as={Button} onClick={trackingEvents} {...ImageCTAStylesMobile[variant].button}>
            {buttonText}
          </Button>
        </Link>
      </Box>
    </Flex>
  );
};

export default ImageCTAMobile;
